/** @deprecated anti-pattern. bloats production code for slightly improved error messages */
export class WorkbenchValidationError extends Error {
  constructor(member: string, value: unknown, context: string) {
    super(`${context}: Value "${String(value)}" is not allowed for property "${member}"`);
  }
}

export class WorkbenchRuntimeError extends Error {
  constructor(message: string, context: string) {
    super(`${context}: ${message}`);
  }
}
